import { Component, OnInit, ElementRef, ViewChild, Input, TemplateRef } from '@angular/core';
import { PhotoSwipeService } from '../photo-swipe.service';
import { PhotoSwipeSlide } from '../entity/PhotoSwipeSlide';
import { PhotoSwipeFigureSlideDownLoadData } from '../entity/PhotoSwipeFigureSlideDownLoadData';
import { fromEvent, Subscription } from 'rxjs';
import { map, takeUntil, debounceTime, skip } from 'rxjs/operators';
import { getElementStyleSize } from '../util';
// import * as Hammer from 'hammerjs';

/**
 * 可手勢滑動的相簿瀏覽器模板
 * 在文檔中只要放一個
 */
@Component({
  selector: 'tm-photo-swipe',
  templateUrl: './photo-swipe.component.html',
  styleUrls: ['./photo-swipe.component.scss'],
})
export class PhotoSwipeComponent implements OnInit {
  data?: PhotoSwipeSlide[];
  currentIndex = 0;
  showthumbnailBar = true;
  isThumbnailOpened = true;
  isOpened = false;
  downloadData?: PhotoSwipeFigureSlideDownLoadData;
  @Input() previousActiveElement: HTMLElement | null = null;
  /** 下載區塊複製授權的文字轉換 */
  @Input() downloadRightsCitationFormatter: (downloadData: PhotoSwipeFigureSlideDownLoadData) => (string|undefined) = () => {
    if (this.downloadData) {
      return `${ this.downloadData.title ? this.downloadData.title + '。' : '' }${ this.downloadData.imageAuthMan ? '授權人：' + this.downloadData.imageAuthMan + '。' : '' }${ this.downloadData.imageAuthorityText ? this.downloadData.imageAuthorityText + '。' : '' }來源：${ this.downloadData.originUrl }。`
    } else {
      return undefined;
    }
  };
  /** 下載區塊複製授權的文字 */
  downloadRightsCitation?: string;
  /** 下載提示窗口模版，若未設定則採用預設的版型，自訂模板須接受一個隱式的參數 */
  @Input() downloadToolTipTmp?: TemplateRef<string>;
  get isCurrentFigureSlide() {
    return this.photoSwipeService.isCurrentFigureSlide;
  }
  get canDownload() {
    return this.photoSwipeService.canDownload;
  }
  @ViewChild('thumbOuter', {static: false}) thumbOuter?: ElementRef;
  @ViewChild('thumb', {static: false}) thumb?: ElementRef;
  get thumbTotalWidth() { return this.thumb ? getElementStyleSize(this.thumb.nativeElement).w : 0; }
  get thumbOuterWidth() { return this.thumbOuter ? getElementStyleSize(this.thumbOuter.nativeElement).w : 0; }
  get isTouchDevice() { return this.photoSwipeService.isTouchDevice; }
  // protected hammerMc: any;
  protected thumbScrollDistance = 0;
  protected thunbMovingSubc?: Subscription;
  hasThumbAnimated = false;

  constructor(
    protected photoSwipeService: PhotoSwipeService
  ) {}

  ngOnInit() {
    this.photoSwipeService.data$.subscribe(data => {
      this.data = data;
    });
    this.photoSwipeService.isOpened$.pipe(skip(1)).subscribe(isOpened => {
      // 當關閉時，聚焦到之前取的activeElement(無障礙)
      if (!isOpened) {
        if (this.previousActiveElement) {
          this.previousActiveElement.focus();
          this.previousActiveElement = null;
        }
      }
      this.isOpened = isOpened;
      this.showthumbnailBar = this.photoSwipeService.showthumbnailBar;
      this.isThumbnailOpened = this.photoSwipeService.showthumbnailBar;
      if (this.showthumbnailBar) { this.initThumbnailSwipe(); }
    });
    this.photoSwipeService.indexChanged$.subscribe(index => {
      if (typeof index === 'number') {
        this.currentIndex = index;
        if (this.showthumbnailBar) {
          if (!this.hasThumbAnimated) {
            this.animateThumb(index);
          } else {
            this.hasThumbAnimated = false;
          }
        }
      }
    });
    this.photoSwipeService.downloadData$.subscribe(dData => {
      this.downloadData = dData;
      this.downloadRightsCitation = this.downloadRightsCitationFormatter(dData as PhotoSwipeFigureSlideDownLoadData);
    });
  }

  /** 切換是否顯示下方縮圖列 */
  toggleThumbnail() {
    this.isThumbnailOpened = !this.isThumbnailOpened;
    if (!this.isTouchDevice) {
      this.initThumbnailSwipe();
    }
  }

  // 用 hammerjs 的版本
  // initThumbnailSwipe() {
  //   if (this.isThumbnailOpened) {
  //     const scrollEl = document.querySelector('.pswp__thumb-scroller');
  //     if (!this.hammerMc) {
  //       this.hammerMc = new Hammer.Manager(scrollEl);
  //       this.hammerMc.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0 }));
  //     }
  //     this.hammerMc.on('swipe', this.swipeThumbnailHandler);
  //   } else if (this.hammerMc) {
  //     this.hammerMc.off('swipe', this.swipeThumbnailHandler);
  //   }
  // }

  // swipeThumbnailHandler = (ev) => {
  //   console.log(ev);
  //   let nd = this.thumbScrollDistance - ev.deltaX;
  //   if (nd > (this.thumbTotalWidth - this.thumbOuterWidth)) { nd = this.thumbTotalWidth - this.thumbOuterWidth; }
  //   if (nd < 0) { nd = 0; }
  //   this.thumbScrollDistance = nd;
  //   this.thumb.nativeElement.setAttribute('style', `transform: translate3d(-${this.thumbScrollDistance}px, 0px, 0px)`);
  // }


  initThumbnailSwipe() {
    const scrollEl = document.querySelector('.pswp__thumb-scroller');
    if (this.isThumbnailOpened && !this.thunbMovingSubc) {
      scrollEl!.addEventListener('mousedown', this.mdThumbnailHandler as any);
    } else if (this.thunbMovingSubc) {
      this.thunbMovingSubc.unsubscribe();
      this.thunbMovingSubc = undefined;
      scrollEl!.removeEventListener('mousedown', this.mdThumbnailHandler as any);
    }
  }

  mdThumbnailHandler = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const mouseUp = fromEvent<MouseEvent>(document, 'mouseup');
    const mouseMove = fromEvent<MouseEvent>(document, 'mousemove');

    const origOffset = this.thumbScrollDistance;
    this.thunbMovingSubc = mouseMove.pipe(
      takeUntil(mouseUp),
      debounceTime(10),
      map(move => {
        let nd = origOffset - (move.clientX - e.clientX);
        if (nd > (this.thumbTotalWidth - this.thumbOuterWidth)) { nd = this.thumbTotalWidth - this.thumbOuterWidth; }
        if (nd < 0) { nd = 0; }
        // console.log(`d: ${e.clientX}, m: ${move.clientX}, odis: ${this.thumbScrollDistance}, origOffset: ${origOffset}, nd: ${nd}`)
        return nd;
      })
    ).subscribe(offset => {
      this.thumbScrollDistance = offset;
      this.thumb?.nativeElement.setAttribute('style', `transform: translate3d(-${offset}px, 0px, 0px)`);
    });
  }

  viewIn(index: number, e: Event) {
    this.photoSwipeService.viewIn(index);
    this.animateThumb(index);
    this.hasThumbAnimated = true;
  }

  copyCitation() {
    const el = document.getElementById('tm_pswp-rights-citation');

    if ((document.body as any).createTextRange) { // IE
      const range = (document.body as any).createTextRange();
      range.moveToElementText(el);
      range.select();
      document.execCommand('Copy');
    } else if (window.getSelection) {
      // other browsers
      const range = document.createRange();
      // range.selectNodeContents(elemID);
      range.selectNode(el as Node);
      const selection = window.getSelection();
      selection!.removeAllRanges();
      selection!.addRange(range);
      document.execCommand('copy');
    }
  }

  animateThumb(index: number) {
    const thumbnailWidth = 100;
    const thumbnailMargin = 5;
    let position;

    position = (this.thumbOuterWidth / 2) - (thumbnailWidth / 2);
    this.thumbScrollDistance = ((thumbnailWidth + thumbnailMargin) * index - 1) - position;

    if (this.thumbScrollDistance > (this.thumbTotalWidth - this.thumbOuterWidth)) {
      this.thumbScrollDistance = this.thumbTotalWidth - this.thumbOuterWidth;
    }

    if (this.thumbScrollDistance < 0) {
      this.thumbScrollDistance = 0;
    }

    this.thumb!.nativeElement.setAttribute('style', `transform: translate3d(-${this.thumbScrollDistance}px, 0px, 0px)`);
  }
}
